import React from "react";
import "./row-bordered.css";
import { Col, Row } from "reactstrap";

export function LayoutHeading({
  children,
  colWidth,
  className,
  colWidthMobile,
}) {
  return (
    <Col
      md={colWidth}
      xs={colWidthMobile || colWidth}
      className={`action-heading cursor-pointer bg-white ${className}`}
      // className={`border py-1 border-grey action-heading cursor-pointer bg-white ${className}`}
    >
      {children}
    </Col>
    // <div
    //   className={`${
    //     colWidth ? `col-md-${colWidth}` : "col"
    //   }  py-1 action-heading cursor-pointer bg-white`}
    // >
    //   {children}
    // </div>
  );
}

// export function LayoutRow({ children }) {
//   return <div className="row mx-1 bottom-border-row-layout">{children}</div>;
// }

export function LayoutRow({ children, className, style, onClick }) {
  return (
    <Row className={className} style={style} onClick={onClick}>
      {children}
    </Row>
  );
}

export function LayoutData({ children, colWidth, className, colWidthMobile }) {
  return (
    <Col
      md={colWidth}
      xs={colWidthMobile || colWidth}
      className={`action-table-data ${className} p-2 border border-grey`}
    >
      {children}
    </Col>
  );
}

// export function LayoutData({ children, colWidth, className }) {
//   return (
//     <div
//       className={`${
//         colWidth ? `col-md-${colWidth}` : "col"
//       }  action-table-data ${className} bg-white`}
//     >
//       {children}
//     </div>
//   );
// }
